import React from 'react'
import './DetailedTimeline.css'


export default function DetailedTimeline (props) {
    return(
        <ul className="vertical-timeline">
            <li className="timeline-point" id='1sthp'>
                <span className="icon-bullet"></span>
                <div className="timeline-point-copy">
                    <date>{props.date[0][0]}<sup>{props.date[0][1]}</sup>{props.date[0][2]}</date>
                    <h1>{props.event[0]}</h1>
                    <h2>{props.role[0]}</h2>
                    <div className="timeline-content">
                        <div className="timeline-content-text">
                            <p><b>Why did we speak to them?</b><br></br>{props.text1[0]}</p>
                            <p><b>Key Highlights:</b><br></br>{props.quote[0]}</p>
                        </div>
                        <div className="timeline-content-text">
                            <p><b>Summary:</b><br></br>{props.text2[0]}</p>
                            <p><b>Discussion:<br></br></b><em>{props.discussion[0][0]}</em><br></br><br></br>{props.discussion[0][1]}</p>
                        </div>
                        <div className="hp-photos">
                            <img src={props.src[0]} alt=''/>
                        </div>
                    </div>
                </div>
            </li>
            <li className="timeline-point" id='2ndhp'>
                <span className="icon-bullet"></span>
                <div className="timeline-point-copy">
                    <date>{props.date[1][0]}<sup>{props.date[1][1]}</sup>{props.date[1][2]}</date>
                    <h1>{props.event[1]}</h1>
                    <h2>{props.role[1]}</h2>
                    <div className="timeline-content">
                        <div className="timeline-content-text">
                            <p><b>Why did we speak to them?</b><br></br>{props.text1[1]}</p>
                            <p><b>Key Highlights:</b><br></br>{props.quote[1]}</p>
                        </div>
                        <div className="timeline-content-text">
                            <p><b>Summary:</b><br></br>{props.text2[1]}</p>
                            <p><b>Discussion:<br></br></b><em>{props.discussion[1][0]}</em><br></br><br></br>{props.discussion[1][1]}</p>
                        </div>
                        <div className="hp-photos">
                            <img src={props.src[1]} alt=''/>
                        </div>
                    </div>
                </div>
            </li>
            <li className="timeline-point" id='3rdhp'>
                <span className="icon-bullet"></span>
                <div className="timeline-point-copy">
                    <date>{props.date[2][0]}<sup>{props.date[2][1]}</sup>{props.date[2][2]}</date>
                    <h1>{props.event[2]}</h1>
                    <h2>{props.role[2]}</h2>
                    <div className="timeline-content">
                        <div className="timeline-content-text">
                            <p><b>Why did we speak to them?</b><br></br>{props.text1[2]}</p>
                            <p><b>Key Highlights:</b><br></br>{props.quote[2]}</p>
                        </div>
                        <div className="timeline-content-text">
                            <p><b>Summary:</b><br></br>{props.text2[2]}</p>
                            <p><b>Discussion:<br></br></b><em>{props.discussion[2][0]}</em><br></br><br></br>{props.discussion[2][1]}</p>
                        </div>
                        <div className="hp-photos">
                            <img src={props.src[2]} alt=''/>
                        </div>
                    </div>
                </div>
            </li>
            <li className="timeline-point" id='4thhp'>
                <span className="icon-bullet"></span>
                <div className="timeline-point-copy">
                    <date>{props.date[3][0]}<sup>{props.date[3][1]}</sup>{props.date[3][2]}</date>
                    <h1>{props.event[3]}</h1>
                    <h2>{props.role[3]}</h2>
                    <div className="timeline-content">
                        <div className="timeline-content-text">
                            <p><b>Why did we speak to them?</b><br></br>{props.text1[3]}</p>
                            <p><b>Key Highlights:</b><br></br>{props.quote[3]}</p>
                        </div>
                        <div className="timeline-content-text">
                            <p><b>Summary:</b><br></br>{props.text2[3]}</p>
                            <p><b>Discussion:<br></br></b><em>{props.discussion[3][0]}</em><br></br><br></br>{props.discussion[3][1]}</p>
                        </div>
                        <div className="hp-photos">
                            <img src={props.src[3]} alt=''/>
                        </div>
                    </div>
                </div>
            </li>
            <li className="timeline-point" id='5thhp'>
                <span className="icon-bullet"></span>
                <div className="timeline-point-copy">
                    <date>{props.date[4][0]}<sup>{props.date[4][1]}</sup>{props.date[4][2]}</date>
                    <h1>{props.event[4]}</h1>
                    <h2>{props.role[4]}</h2>
                    <div className="timeline-content">
                        <div className="timeline-content-text">
                            <p><b>Why did we speak to them?</b><br></br>{props.text1[4]}</p>
                            <p><b>Key Highlights:</b><br></br>{props.quote[4]}</p>
                        </div>
                        <div className="timeline-content-text">
                            <p><b>Summary:</b><br></br>{props.text2[4]}</p>
                            <p><b>Discussion:<br></br></b><em>{props.discussion[4][0]}</em><br></br><br></br>{props.discussion[4][1]}</p>
                        </div>
                        <div className="hp-photos">
                            <img src={props.src[4]} alt=''/>
                        </div>
                    </div>
                </div>
            </li>              
            <li className="timeline-point" id='6thhp'>
                <span className="icon-bullet"></span>
                <div className="timeline-point-copy">
                    <date>{props.date[5][0]}<sup>{props.date[5][1]}</sup>{props.date[5][2]}</date>
                    <h1>{props.event[5]}</h1>
                    <h2>{props.role[5]}</h2>
                    <div className="timeline-content">
                        <div className="timeline-content-text">
                            <p><b>Why did we speak to them?</b><br></br>{props.text1[5]}</p>
                            <p><b>Key Highlights:</b><br></br>{props.quote[5]}</p>
                        </div>
                        <div className="timeline-content-text">
                            <p><b>Summary:</b><br></br>{props.text2[5]}</p>
                            <p><b>Discussion:<br></br></b><em>{props.discussion[5][0]}</em><br></br><br></br>{props.discussion[5][1]}</p>
                        </div>
                        <div className="hp-photos">
                            <img src={props.src[5]} alt=''/>
                        </div>
                    </div>
                </div>
            </li>
            <li className="timeline-point" id='7thhp'>
                <span className="icon-bullet"></span>
                <div className="timeline-point-copy">
                    <date>{props.date[6][0]}<sup>{props.date[6][1]}</sup>{props.date[6][2]}</date>
                    <h1>{props.event[6]}</h1>
                    <h2>{props.role[6]}</h2>
                    <div className="timeline-content">
                        <div className="timeline-content-text">
                            <p><b>Why did we speak to them?</b><br></br>{props.text1[6]}</p>
                            <p><b>Key Highlights:</b><br></br>{props.quote[6]}</p>
                        </div>
                        <div className="timeline-content-text">
                            <p><b>Summary:</b><br></br>{props.text2[6]}</p>
                            <p><b>Discussion:<br></br></b><em>{props.discussion[6][0]}</em><br></br><br></br>{props.discussion[6][1]}</p>
                        </div>
                        <div className="hp-photos">
                            <img src={props.src[6]} alt=''/>
                        </div>
                    </div>
                </div>
            </li>    
            <li className="timeline-point" id='8thhp'>
                <span className="icon-bullet"></span>
                <div className="timeline-point-copy">
                    <date>{props.date[7][0]}<sup>{props.date[7][1]}</sup>{props.date[7][2]}</date>
                    <h1>{props.event[7]}</h1>
                    <h2>{props.role[7]}</h2>
                    <div className="timeline-content">
                        <div className="timeline-content-text">
                            <p><b>Why did we speak to them?</b><br></br>{props.text1[7]}</p>
                            <p><b>Key Highlights:</b><br></br>{props.quote[7]}</p>
                        </div>
                        <div className="timeline-content-text">
                            <p><b>Summary:</b><br></br>{props.text2[7]}</p>
                            <p><b>Discussion:<br></br></b><em>{props.discussion[7][0]}</em><br></br><br></br>{props.discussion[7][1]}</p>
                        </div>
                        <div className="hp-photos">
                            <img src={props.src[7]} alt=''/>
                        </div>
                    </div>
                </div>
            </li>    
            <li className="timeline-point" id='9thhp'>
                <span className="icon-bullet"></span>
                <div className="timeline-point-copy">
                    <date>{props.date[8][0]}<sup>{props.date[8][1]}</sup>{props.date[8][2]}</date>
                    <h1>{props.event[8]}</h1>
                    <h2>{props.role[8]}</h2>
                    <div className="timeline-content">
                        <div className="timeline-content-text">
                            <p><b>Why did we speak to them?</b><br></br>{props.text1[8]}</p>
                            <p><b>Key Highlights:</b><br></br>{props.quote[8]}</p>
                        </div>
                        <div className="timeline-content-text">
                            <p><b>Summary:</b><br></br>{props.text2[8]}</p>
                            <p><b>Discussion:<br></br></b><em>{props.discussion[8][0]}</em><br></br><br></br>{props.discussion[8][1]}</p>
                        </div>
                        <div className="hp-photos">
                            <img src={props.src[8]} alt=''/>
                        </div>
                    </div>
                </div>
            </li>    
            <li className="timeline-point" id='10thhp'>
                <span className="icon-bullet"></span>
                <div className="timeline-point-copy">
                    <date>{props.date[9][0]}<sup>{props.date[9][1]}</sup>{props.date[9][2]}</date>
                    <h1>{props.event[9]}</h1>
                    <h2>{props.role[9]}</h2>
                    <div className="timeline-content">
                        <div className="timeline-content-text">
                            <p><b>Why did we speak to them?</b><br></br>{props.text1[9]}</p>
                            <p><b>Key Highlights:</b><br></br>{props.quote[9]}</p>
                        </div>
                        <div className="timeline-content-text">
                            <p><b>Summary:</b><br></br>{props.text2[9]}</p>
                            <p><b>Discussion:<br></br></b><em>{props.discussion[9][0]}</em><br></br><br></br>{props.discussion[9][1]}</p>
                        </div>
                        <div className="hp-photos">
                            <img src={props.src[9]} alt=''/>
                        </div>
                    </div>
                </div>
            </li>
            <li className="timeline-point" id='11thhp'>
                <span className="icon-bullet"></span>
                <div className="timeline-point-copy">
                    <date>{props.date[10][0]}<sup>{props.date[10][1]}</sup>{props.date[10][2]}</date>
                    <h1>{props.event[10]}</h1>
                    <h2>{props.role[10]}</h2>
                    <div className="timeline-content">
                        <div className="timeline-content-text">
                            <p><b>Why did we speak to them?</b><br></br>{props.text1[10]}</p>
                            <p><b>Key Highlights:</b><br></br>{props.quote[10]}</p>
                        </div>
                        <div className="timeline-content-text">
                            <p><b>Summary:</b><br></br>{props.text2[10]}</p>
                            <p><b>Discussion:<br></br></b><em>{props.discussion[10][0]}</em><br></br><br></br>{props.discussion[10][1]}</p>
                        </div>
                        <div className="hp-photos">
                            <img src={props.src[10]} alt=''/>
                        </div>
                    </div>
                </div>
            </li>
            <li className="timeline-point" id='12thhp'>
                <span className="icon-bullet"></span>
                <div className="timeline-point-copy">
                    <date>{props.date[11][0]}<sup>{props.date[11][1]}</sup>{props.date[11][2]}</date>
                    <h1>{props.event[11]}</h1>
                    <h2>{props.role[11]}</h2>
                    <div className="timeline-content">
                        <div className="timeline-content-text">
                            <p><b>Why did we speak to them?</b><br></br>{props.text1[11]}</p>
                            <p><b>Key Highlights:</b><br></br>{props.quote[11]}</p>
                        </div>
                        <div className="timeline-content-text">
                            <p><b>Summary:</b><br></br>{props.text2[11]}</p>
                            <p><b>Discussion:<br></br></b><em>{props.discussion[11][0]}</em><br></br><br></br>{props.discussion[11][1]}</p>
                        </div>
                        <div className="hp-photos">
                            <img src={props.src[11]} alt=''/>
                        </div>
                    </div>
                </div>
            </li> 
            <li className="timeline-point" id='13thhp'>
                <span className="icon-bullet"></span>
                <div className="timeline-point-copy">
                    <date>{props.date[12][0]}<sup>{props.date[12][1]}</sup>{props.date[12][2]}</date>
                    <h1>{props.event[12]}</h1>
                    <h2>{props.role[12]}</h2>
                    <div className="timeline-content">
                        <div className="timeline-content-text">
                            <p><b>Why did we speak to them?</b><br></br>{props.text1[12]}</p>
                            <p><b>Key Highlights:</b><br></br>{props.quote[12]}</p>
                        </div>
                        <div className="timeline-content-text">
                            <p><b>Summary:</b><br></br>{props.text2[12]}</p>
                            <p><b>Discussion:<br></br></b><em>{props.discussion[12][0]}</em><br></br><br></br>{props.discussion[12][1]}</p>
                        </div>
                        <div className="hp-photos">
                            <img src={props.src[12]} alt=''/>
                        </div>
                    </div>
                </div>
            </li> 
            <li className="timeline-point" id='14thhp'>
                <span className="icon-bullet"></span>
                <div className="timeline-point-copy">
                    <date>{props.date[13][0]}<sup>{props.date[13][1]}</sup>{props.date[13][2]}</date>
                    <h1>{props.event[13]}</h1>
                    <h2>{props.role[13]}</h2>
                    <div className="timeline-content">
                        <div className="timeline-content-text">
                            <p><b>Why did we speak to them?</b><br></br>{props.text1[13]}</p>
                            <p><b>Key Highlights:</b><br></br>{props.quote[13]}</p>        
                        </div>
                        <div className="timeline-content-text">
                            <p><b>Summary:</b><br></br>{props.text2[13]}</p>
                            <p><b>Discussion:<br></br></b><em>{props.discussion[13][0]}</em><br></br><br></br>{props.discussion[13][1]}</p>
                        </div>
                        <div className="hp-photos">
                            <img src={props.src[13]} alt=''/>
                        </div>
                    </div>
                </div>
            </li>
            <li className="timeline-point" id='15thhp'>
                <span className="icon-bullet"></span>
                <div className="timeline-point-copy">
                    <date>{props.date[14][0]}<sup>{props.date[14][1]}</sup>{props.date[14][2]}</date>
                    <h1>{props.event[14]}</h1>
                    <h2>{props.role[14]}</h2>
                    <div className="timeline-content">
                        <div className="timeline-content-text">
                            <p><b>Why did we speak to them?</b><br></br>{props.text1[14]}</p>
                            <p><b>Key Highlights:</b><br></br>{props.quote[14]}</p>            
                        </div>
                        <div className="timeline-content-text">
                            <p><b>Summary:</b><br></br>{props.text2[14]}</p>
                            <p><b>Discussion:<br></br></b><em>{props.discussion[14][0]}</em><br></br><br></br>{props.discussion[14][1]}</p>
                        </div>
                        <div className="hp-photos">
                            <img src={props.src[14]} alt=''/>
                        </div>
                    </div>
                </div>
            </li>   
            <li className="timeline-point" id='16thhp'>
                <span className="icon-bullet"></span>
                <div className="timeline-point-copy">
                    <date>{props.date[15][0]}<sup>{props.date[15][1]}</sup>{props.date[15][2]}</date>
                    <h1>{props.event[15]}</h1>
                    <h2>{props.role[15]}</h2>
                    <div className="timeline-content">
                        <div className="timeline-content-text">
                            <p><b>Why did we speak to them?</b><br></br>{props.text1[15]}</p>
                            <p><b>Key Highlights:</b><br></br>{props.quote[15]}</p>
                        </div>
                        <div className="timeline-content-text">
                            <p><b>Summary:</b><br></br>{props.text2[15]}</p>
                            <p><b>Discussion:<br></br></b><em>{props.discussion[15][0]}</em><br></br><br></br>{props.discussion[15][1]}</p>
                        </div>
                        <div className="hp-photos">
                            <img src={props.src[15]} alt=''/>
                        </div>
                    </div>
                </div>
            </li>     
            <li className="timeline-point" id='17thhp'>
                <span className="icon-bullet"></span>
                <div className="timeline-point-copy">
                    <date>{props.date[16][0]}<sup>{props.date[16][1]}</sup>{props.date[16][2]}</date>
                    <h1>{props.event[16]}</h1>
                    <h2>{props.role[16]}</h2>
                    <div className="timeline-content">
                        <div className="timeline-content-text">
                            <p><b>Why did we speak to them?</b><br></br>{props.text1[16]}</p>
                            <p><b>Key Highlights:</b><br></br>{props.quote[16]}</p>
                        </div>
                        <div className="timeline-content-text">
                            <p><b>Summary:</b><br></br>{props.text2[16]}</p>
                            <p><b>Discussion:<br></br></b><em>{props.discussion[16][0]}</em><br></br><br></br>{props.discussion[16][1]}</p>
                        </div>
                        <div className="hp-photos">
                            <img src={props.src[16]} alt=''/>
                        </div>
                    </div>
                </div>
            </li> 
            <li className="timeline-point" id='18thhp'>
                <span className="icon-bullet"></span>
                <div className="timeline-point-copy">
                    <date>{props.date[17][0]}<sup>{props.date[17][1]}</sup>{props.date[17][2]}</date>
                    <h1>{props.event[17]}</h1>
                    <h2>{props.role[17]}</h2>
                    <div className="timeline-content">
                        <div className="timeline-content-text">
                            <p><b>Why did we speak to them?</b><br></br>{props.text1[17]}</p>
                            <p><b>Key Highlights:</b><br></br>{props.quote[17]}</p>            
                        </div>
                        <div className="timeline-content-text">
                            <p><b>Summary:</b><br></br>{props.text2[17]}</p>
                            <p><b>Discussion:<br></br></b><em>{props.discussion[17][0]}</em><br></br><br></br>{props.discussion[17][1]}</p>
                        </div>
                        <div className="hp-photos">
                            <img src={props.src[17]} alt=''/>
                        </div>
                    </div>
                </div>
            </li> 
            <li className="timeline-point" id='19thhp'>
                <span className="icon-bullet"></span>
                <div className="timeline-point-copy">
                    <date>{props.date[18][0]}<sup>{props.date[18][1]}</sup>{props.date[18][2]}</date>
                    <h1>{props.event[18]}</h1>
                    <h2>{props.role[18]}</h2>
                    <div className="timeline-content">
                        <div className="timeline-content-text">
                            <p><b>Why did we speak to them?</b><br></br>{props.text1[18]}</p>
                            <p><b>Key Highlights:</b><br></br>{props.quote[18]}</p>            
                        </div>
                        <div className="timeline-content-text">
                            <p><b>Summary:</b><br></br>{props.text2[18]}</p>
                            <p><b>Discussion:<br></br></b><em>{props.discussion[18][0]}</em><br></br><br></br>{props.discussion[18][1]}</p>
                        </div>
                        <div className="hp-photos">
                            <img src={props.src[18]} alt=''/>
                        </div>
                    </div>
                </div>
            </li> 
            <li className="timeline-point" id='20thhp'>
                <span className="icon-bullet"></span>
                <div className="timeline-point-copy">
                    <date>{props.date[19][0]}<sup>{props.date[19][1]}</sup>{props.date[19][2]}</date>
                    <h1>{props.event[19]}</h1>
                    <h2>{props.role[19]}</h2>
                    <div className="timeline-content">
                        <div className="timeline-content-text">
                            <p><b>Why did we speak to them?</b><br></br>{props.text1[19]}</p>
                            <p><b>Key Highlights:</b><br></br>{props.quote[19]}</p>            
                        </div>
                        <div className="timeline-content-text">
                            <p><b>Summary:</b><br></br>{props.text2[19]}</p>
                            <p><b>Discussion:<br></br></b><em>{props.discussion[19][0]}</em><br></br><br></br>{props.discussion[19][1]}</p>
                        </div>
                        <div className="hp-photos">
                            <img src={props.src[19]} alt=''/>
                        </div>
                    </div>
                </div>
            </li>   
        </ul> 
    )
}